import { navigateTo } from "gatsby-link";

/**
 * improves upon Gatsby's React Router navigateTo function by
 * allowing absolute urls to be opened correctly
 * @param url
 */
export default function(url: string) {
	if (url.indexOf("http:") === 0 || url.indexOf("https:") === 0) {
		// open in a new window/tab
		window.open(url);
	} else if (url.indexOf("mailto:") === 0) {
		// open without creating a blank window/tab
		window.location.assign(url);
	} else {
		// relative url...
		// default to gatsby-link's implementation
		navigateTo(url);
	}
}



// WEBPACK FOOTER //
// ./src/utils/navigate_to.ts